(() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-jfg-native-menu]').forEach(root => {
      if (root.dataset.jfgReady) return;
      root.dataset.jfgReady = 'true';
      const desktop = root.classList.contains('jfg-native-menu--desktop');
      const branches = [...root.querySelectorAll('details.jfg-menu-branch')];
      const timers = new WeakMap();
      const setOpen = (branch, open) => {
        branch.open = open;
        branch.querySelector(':scope > summary').setAttribute('aria-expanded', String(open));
        if (!open) branch.querySelectorAll('details[open]').forEach(child => setOpen(child, false));
        if (open) {
          const siblings = branch.parentElement.parentElement;
          [...siblings.children].forEach(li => { const sibling = li.querySelector(':scope > details'); if (sibling && sibling !== branch) setOpen(sibling, false); });
          if (desktop) {
            branch.classList.remove('jfg-fly-left', 'jfg-align-right');
            const panel = branch.querySelector(':scope > .jfg-menu-panel');
            if (panel && panel.getBoundingClientRect().right > document.documentElement.clientWidth - 8) {
              branch.classList.add(branch.parentElement.classList.contains('jfg-menu-root') ? 'jfg-align-right' : 'jfg-fly-left');
            }
          }
        }
      };
      const closeAll = () => branches.filter(branch => branch.open).forEach(branch => setOpen(branch, false));
      root.addEventListener('click', event => {
        const summary = event.target.closest('summary.jfg-menu-link');
        if (!summary || !root.contains(summary)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const branch = summary.parentElement;
        clearTimeout(timers.get(branch));
        setOpen(branch, !branch.open);
      }, true);
      branches.forEach(branch => {
        branch.addEventListener('pointerenter', event => { if (!desktop || event.pointerType !== 'mouse') return; clearTimeout(timers.get(branch)); timers.set(branch, setTimeout(() => setOpen(branch, true), 100)); });
        branch.addEventListener('pointerleave', event => { if (!desktop || event.pointerType !== 'mouse') return; clearTimeout(timers.get(branch)); timers.set(branch, setTimeout(() => { if (!branch.contains(document.activeElement)) setOpen(branch, false); }, 180)); });
      });
      root.addEventListener('keydown', event => {
        const summary = event.target.closest('summary');
        if (event.key === 'Escape') {
          event.preventDefault(); event.stopPropagation();
          const branch = event.target.closest('details.jfg-menu-branch');
          if (branch?.open) { setOpen(branch, false); branch.querySelector(':scope > summary').focus(); }
          else { const ancestor = branch?.parentElement.closest('details.jfg-menu-branch'); if (ancestor) { setOpen(ancestor, false); ancestor.querySelector(':scope > summary').focus(); } }
        } else if (summary && ['ArrowDown', 'ArrowRight'].includes(event.key)) {
          event.preventDefault(); setOpen(summary.parentElement, true);
          summary.nextElementSibling?.querySelector('summary, a')?.focus();
        } else if (event.key === 'ArrowLeft') {
          const branch = event.target.closest('ul.jfg-menu-panel')?.parentElement;
          if (branch?.matches('details')) { event.preventDefault(); setOpen(branch, false); branch.querySelector(':scope > summary').focus(); }
        }
      });
      root.addEventListener('keyup', event => { if (event.key === 'Escape') event.stopPropagation(); });
      root.addEventListener('focusout', () => { if (desktop) setTimeout(() => { if (!root.contains(document.activeElement) && !root.matches(':hover')) closeAll(); }, 0); });
      document.addEventListener('pointerdown', event => { if (!root.contains(event.target)) closeAll(); });
      document.addEventListener('jfg:close-menu', closeAll);
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

